import { AuthenticateWithRedirectCallback } from "@clerk/tanstack-react-start";
import { createFileRoute } from "@tanstack/react-router";

/**
 * Orca OAuth (SSO) return route — completes the Clerk social-login round-trip
 * for `<SignIn routing="path">` at `/orca/login`.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/orca/login/sso-callback")({
  component: OrcaSSOCallback,
});

export function OrcaSSOCallback() {
  return <AuthenticateWithRedirectCallback />;
}
